"use strict";

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.reduce");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var hideWhen = function hideWhen(ruleData, form) {
  if (ruleData.hasOwnProperty('and')) {
    return ruleData.and.reduce(function (acc, currentValue) {
      return acc && hideWhen(currentValue, form);
    }, true);
  }

  if (ruleData.hasOwnProperty('or')) {
    return ruleData.or.reduce(function (acc, currentValue) {
      return acc || hideWhen(currentValue, form);
    }, false);
  }

  var targetField;

  try {
    targetField = form.$(ruleData.id);
  } catch (e) {
    targetField = null;
  } // If a field isn't shown, ignore it.


  if (!targetField || !targetField.isShown) {
    return false;
  }

  var targetValue;

  if (targetField) {
    targetValue = targetField.value;
  } else {
    targetValue = null;
  } // If target is an array of options (eg checkbox group) then iterate selected values


  if (Array.isArray(targetValue)) {
    return targetValue.find(function (v) {
      return v === ruleData.value;
    });
  }

  return targetValue === ruleData.value;
};

var _default = hideWhen;
exports.default = _default;
//# sourceMappingURL=hideWhen.js.map